export default __webpack_public_path__ + "static/media/examination-checklists-icon.212d5603.svg";